import { render, staticRenderFns } from "./TopCovers.vue?vue&type=template&id=641fe98c&scoped=true"
import script from "./TopCovers.vue?vue&type=script&lang=ts"
export * from "./TopCovers.vue?vue&type=script&lang=ts"
import style0 from "./TopCovers.vue?vue&type=style&index=0&id=641fe98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641fe98c",
  null
  
)

export default component.exports